// extracted by mini-css-extract-plugin
export default {"cls1":"ia_pRDAe8ooa4tu2ar2B","cls2":"SskbBb76oLRIiMiDUtbj ia_pRDAe8ooa4tu2ar2B","isPhone":"AMVgwGxRTd5r7zyY48qB"};